<div class="row">
    <div class="col">
        <div class="container-fluid">
            <div class="row">
                <div class="col d-flex align-items-center mb-1">
                    <app-svg-icon *ngIf="item.Checkpoint" [size]="16" icon="patch-check-fill"
                        class="text-primary me-1"></app-svg-icon>
                    <h3 class="mb-0 pe-1 mas-chico" [style.color]="color"
                        [attr.item-id]="!accesoPublico ? item.Id : null" container="body"
                        ngbTooltip="{{!accesoPublico ? item.Id : null}}">
                        {{ item.IdRelativo }}
                    </h3>
                    <input type="text" class="form-control white-borders"
                        [(ngModel)]="item.Texto" [disabled]="accesoPublico" />
                </div>
                <div class="col flex-grow-0 text-end my-auto pe-0" *ngIf="item.Condiciones">
                    <app-svg-icon class="me-2" icon="eye" [size]="20" (click)="abrirEditorCondiciones()">
                    </app-svg-icon>
                </div>
                <div class="col flex-grow-0 text-end my-auto pe-0">
                    <span *ngIf="!tieneImagen" class="text-nowrap">Falta imagen</span>
                    <app-svg-icon class="me-2" icon="image" [size]="20" *ngIf="tieneImagen" [ngbTooltip]="imagenTooltip"
                        placement="left"></app-svg-icon>
                </div>
                <div class="col flex-grow-0 text-end my-auto">
                    <div ngbDropdown class="d-inline-block" container="body" *ngIf="!accesoPublico">
                        <app-svg-icon ngbDropdownToggle class="dropdown-sin-flecha" [size]="24"
                            icon="three-dots-vertical"></app-svg-icon>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="borrarItem.emit()">Borrar</button>
                            <button ngbDropdownItem (click)="abrirEditorCondiciones()">
                                Editor de condiciones
                            </button>
                            <div ngbDropdownItem (click)="abrirAcciones.emit()">Acciones</div>
                            <div ngbDropdownItem [command]="subirImagenItemCmd">Subir imagen</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #imagenTooltip>
    <img [src]="s3URL + '/images/items/' + item.Id + '.jpg'"
        [alt]="'Imagen ' + item.Id">
</ng-template>
